import { fabric } from "fabric";
import { v4 as uuid } from "uuid";
import { loadImageForFabric } from "../utils/resolveMediaUrl";
import { formatLiquidCrystalDateTime } from "./utils/liquidCrystalClockFormat";
import { formatLongformClockDisplay } from "./utils/longformClockFormat";
import {
  defaultWeatherSnapshot,
  formatTempDisplay,
  formatWindDisplay,
} from "./utils/weatherApi";
import { mergeWeatherObjStyle } from "./utils/weatherWidgetStyle";
import { weatherIconEmoji, WEATHER_ICON_FONT } from "./utils/weatherEmoji";
export default class EditorOps {
  /** Name of the line drawn between floors in a directory register. */
  static REGISTER_FLOOR_SEPARATOR = "register-floor-separator";
  /** registerObj._floorStyle of registers built with the line between floors. */
  static REGISTER_FLOOR_STYLE = 2;

  // constructor() {
  //   fabric.Object.prototype.toObject = (function (originalToObject) {
  //     return function () {
  //       // Extend the default object serialization with custom properties
  //       return fabric.util.object.extend(originalToObject.call(this), {
  //         id: this.id || "",
  //         name: this.name || "",
  //         eleType: this.eleType || "",
  //         text: this.text || "",
  //         url: this.url || "",
  //         fontSize: this.fontSize || "",
  //         contents: this.contents || [],
  //         weatherObj: this.weatherObj || {},
  //         scaletype: this.scaletype || {},
  //         tempObj: this.tempObj || {},
  //         zoom: this.zoom || "",
  //         scrollstrip: this.scrollstrip || {},
  //       });
  //     };
  //   })(fabric.Object.prototype.toObject);
  // }

  constructor() {
    // Override the default toObject method for all fabric objects
    fabric.Object.prototype.toObject = (function (originalToObject) {
      // 1. Accept the propertiesToInclude argument
      return function (propertiesToInclude) { 
        
        // 2. Call the original toObject and PASS the propertiesToInclude argument.
        // This ensures base Fabric properties are filtered correctly first.
        const baseObject = originalToObject.call(this, propertiesToInclude); 
        
        // 3. Extend the result with your custom properties, ensuring they are always present.
        return fabric.util.object.extend(baseObject, {
          id: this.id || "",
          name: this.name || "",
          eleType: this.eleType || "",
          text: this.text || "",
          url: this.url || "",
          linkUrl: this.linkUrl || "",
          fontSize: this.fontSize || "",
          contents: this.contents || [],
          playlistId: this.playlistId || "",
          weatherObj: this.weatherObj || {},
          scaletype: this.scaletype || {},
          tempObj: this.tempObj || {},
          zoom: this.zoom || "",
          scrollstrip: this.scrollstrip || {},
          registerObj: this.registerObj || null,
          clockObj: this.clockObj || null,
        });
      };
    })(fabric.Object.prototype.toObject);
  }
  
  createRect() {
    return new fabric.Rect({
      id: uuid(),
      top: 50,
      left: 50,
      shapeType: "rect",
      name: "Shape",
      // cornerColor: "black",
      // borderColor:'red',
      // backgroundColor:'green',
      width: 100,
      height: 100,
      fill: "gray",
      stroke: "black",
      strokeWidth: 1,
    });
  }
  createCircle() {
    return new fabric.Circle({
      id: uuid(),
      shapeType: "circle",
      name: "Shape",
      top: 50,
      left: 50,
      // cornerColor: "black",
      // borderColor: "red",
      width: 300,
      height: 300,
      radius: 50,
      stroke: "black",
      // strokeWidth: 2,
      fill: "gray",
    });
  }
  createLine() {
    return new fabric.Line([50, 50, 250, 50], {
      id: uuid(),
      shapeType: "line",
      name: "Shape",
      stroke: "black",
      strokeWidth: 2,
      // strokeDashArray: [1, 1]
    });
  }
  createPolygone() {
    return new fabric.Polygon(
      [
        {
          x: 150,
          y: 50,
        },
        {
          x: 225,
          y: 150,
        },
        {
          x: 150,
          y: 250,
        },
        {
          x: 75,
          y: 150,
        },
      ],
      {
        id: uuid(),
        name: "Shape",
        shapeType: "polygon",
        fill: "gray",
        stroke: "black",
        strokeWidth: 2,
      }
    );
  }
  createTriangle() {
    return new fabric.Triangle({
      id: uuid(),
      shapeType: "triangle",
      eleType: "triangle",
      name: "Shape",
      width: 100,
      height: 100,
      stroke: "black",
      strokeWidth: 2,
      fill: "transparent",
      left: 50,
      top: 50,
    });
  }
  addEmojiToCanvas(emoji) {
    return new fabric.Text(emoji, {
      id: uuid(),
      name: "Text",
      top: 50,
      left: 50,
      editable: true,
      // cornerColor: "black",
      // borderColor: "red",
      textAlign: "center",
      selectable: true,
    });
  }
  addTextToCanvas(text, type) {
    return new fabric.Text(text, {
      id: uuid(),
      eleType: type,
      scaleX:1.3,
      scaleY:1.3,
      name: "Text",
      top: 50,
      left: 50,
      editable: true,
      // cornerColor: "black",
      // borderColor: "red",
      textAlign: "center",
      selectable: true,
    });
  }
  addTextStripBox(text, fontSize = 30, obj) {
    // console.log(text,obj)
    return new fabric.Textbox(text, {
      id: uuid(),
      name: "Textbox",
      fontSize: fontSize,
      top: 50,
      left: 50,
      scrollstrip: obj,
      editable: false,
      eleType: "scrollstrip",
      textAlign: "center",
      selectable: true,
    });
  }
  addShadow() {
    return new fabric.Shadow({
      color: "black",
      blur: 5,
      offsetX: 10,
      offsetY: 10,
    });
  }
  addTextbox(text, fontSize) {
    return new fabric.Textbox(text, {
      id: uuid(),
      name: "Textbox",
      fontSize: fontSize,
      top: 50,
      left: 50,
      // right:70,
      // bottom:70,
      editable: true,
      eleType: "text",
      // cornerColor: "black",
      // borderColor: "black",
      textAlign: "center",
    });
  }

  addAnalogClock(url, type, a) {
    loadImageForFabric(url)
      .then(({ img, storageUrl }) => {
        img.scale(0.3);
        img.set({
          id: uuid(),
          url: storageUrl,
          paintFirst: "fill",
          cornerColor: "black",
          eleType: type,
          lockScalingFlip: true,
          hasControls: true,
        });

        a(img);
      })
      .catch((err) => {
        console.error("addAnalogClock failed:", url, err);
        a(null);
      });
  }

  /**
   * Replace a layout library image (nor-image) with a new asset while keeping
   * on-canvas size, position, angle, opacity, stroke, shadow, and metadata id.
   */
  replaceNorImage(target, newUrl, newName, onDone) {
    const done = typeof onDone === "function" ? onDone : () => {};
    if (!target) {
      done(null);
      return;
    }
    const isNor =
      target.eleType === "nor-image" ||
      (target.type === "nor-image" && !target.contents && !target.weatherObj);
    if (!isNor) {
      done(null);
      return;
    }
    const sw = target.getScaledWidth();
    const sh = target.getScaledHeight();
    const base = {
      id: target.id,
      left: target.left,
      top: target.top,
      angle: target.angle,
      flipX: target.flipX,
      flipY: target.flipY,
      skewX: target.skewX || 0,
      skewY: target.skewY || 0,
      opacity: target.opacity,
      originX: target.originX,
      originY: target.originY,
      cornerColor: target.cornerColor,
      paintFirst: target.paintFirst,
      transparentCorners: target.transparentCorners,
      borderColor: target.borderColor,
      stroke: target.stroke,
      strokeWidth: target.strokeWidth,
      lockScalingFlip: target.lockScalingFlip,
      hasControls: target.hasControls,
      selectable: target.selectable,
      evented: target.evented,
      visible: target.visible,
      eleType: "nor-image",
      scaletype: target.scaletype ? { ...target.scaletype } : { fitXY: true, none: false },
      linkUrl: target.linkUrl,
    };
    if (target.shadow) {
      try {
        base.shadow = fabric.util.object.clone(target.shadow);
      } catch (_) {
        base.shadow = target.shadow;
      }
    }

    loadImageForFabric(newUrl)
      .then(({ img, storageUrl }) => {
        const nw = Math.max(img.width || 1, 1e-6);
        const nh = Math.max(img.height || 1, 1e-6);
        img.set({
          ...base,
          url: storageUrl,
          _name: newName,
          scaleX: sw / nw,
          scaleY: sh / nh,
        });
        const finish = () => done(img);
        if (Array.isArray(target.filters) && target.filters.length) {
          img.filters = target.filters.slice();
          if (typeof img.applyFilters === "function") {
            try {
              img.applyFilters(finish);
            } catch (_) {
              finish();
            }
          } else {
            finish();
          }
        } else {
          finish();
        }
      })
      .catch((err) => {
        console.error("replaceNorImage failed:", newUrl, err);
        done(null);
      });
  }

  addImage(url,name, type, a) {
    loadImageForFabric(url)
      .then(({ img, storageUrl }) => {
        img.scale(0.3);
        img.set({
          id: uuid(),
          url: storageUrl,
          _name:name,
          scaletype: { fitXY: true, none: false },
          paintFirst: "fill",
          cornerColor: "black",
          eleType: type,
        });

        a(img);
      })
      .catch((err) => {
        console.error("addImage failed:", url, err);
        a(null);
      });
  }
  addLocalContent( imgurl,url,name,type, cb) {
    loadImageForFabric(imgurl)
      .then(({ img, storageUrl }) => {
        img.scale(0.3);
        img.set({
          id: uuid(),
          url: url || storageUrl,
          _name:name,
          scaletype: { fitXY: true, none: false },
          paintFirst: "fill",
          cornerColor: "black",
          eleType: type,
        });

        cb(img);
      })
      .catch((err) => {
        console.error("addLocalContent failed:", imgurl, err);
        cb(null);
      });
  }
  addWeather(imgsrc, obj, type, cb) {
    loadImageForFabric(imgsrc)
      .then(({ img }) => {
        img.scale(1);
        img.set({
          id: uuid(),
          url: "",
          weatherObj: obj,
          paintFirst: "fill",
          cornerColor: "black",
          eleType: type,
        });

        cb(img);
      })
      .catch((err) => {
        console.error("addWeather failed:", imgsrc, err);
        cb(null);
      });
  }

  addTemp(imgsrc, obj, type, cb) {
    loadImageForFabric(imgsrc)
      .then(({ img }) => {
        img.scale(1);
        img.set({
          id: uuid(),
          url: "",
          tempObj: obj,
          paintFirst: "fill",
          cornerColor: "black",
          eleType: type,
        });

        cb(img);
      })
      .catch((err) => {
        console.error("addTemp failed:", imgsrc, err);
        cb(null);
      });
  }

  addPlaylist(imgsrc,name, content, cb, playlistId) {
    loadImageForFabric(imgsrc)
      .then(({ img }) => {
        img.scale(0.3);
        img.set({
          id: uuid(),
          url: "",
          _name:name,
          contents: content,
          playlistId: playlistId ? String(playlistId) : "",
          scaletype: { fitXY: true, none: false },
          paintFirst: "fill",
          cornerColor: "black",
          eleType: "playlist",
        });

        cb(img);
      })
      .catch((err) => {
        console.error("addPlaylist failed:", imgsrc, err);
        cb(null);
      });
  }

  addLinkButton(text, eleType, linkUrl) {
    return new fabric.Textbox(text, {
      id: uuid(),
      name: "Textbox",
      fontSize: 24,
      top: 50,
      left: 50,
      width: 160,
      editable: true,
      eleType,
      linkUrl: linkUrl || (eleType === "login" ? "/login" : "/register"),
      textAlign: "center",
      fill: "#008080",
    });
  }

  /** Chars per line for hard-wrap (same rule as layout height estimates). */
  static _registerCharsPerLine(fontSize, colW) {
    return Math.max(4, Math.floor(colW / (fontSize * 0.52)));
  }

  /** Newline-wrapped string for fabric.Text (avoids fabric.Textbox init / setCoords recursion in Fabric 5). */
  static _registerHardWrapText(text, fontSize, colW) {
    const cpl = EditorOps._registerCharsPerLine(fontSize, colW);
    const t = String(text ?? "");
    if (t.length === 0) return " ";
    const parts = [];
    for (let i = 0; i < t.length; i += cpl) {
      parts.push(t.slice(i, i + cpl));
    }
    return parts.join("\n");
  }

  static _registerWrappedLineCount(text, fontSize, colW) {
    const cpl = EditorOps._registerCharsPerLine(fontSize, colW);
    const t = String(text || "");
    return Math.max(1, Math.ceil(Math.max(1, t.length) / cpl));
  }

  /** Block height for a wrapped text run; use this for Y stepping instead of fabric.Textbox.height (avoids runaway box growth). */
  static _registerTextBlockHeight(text, fontSize, colW, lineHeightFn) {
    return (
      EditorOps._registerWrappedLineCount(text, fontSize, colW) *
      lineHeightFn(fontSize)
    );
  }

  /** Rough height for one floor block (matches _renderFloorInColumn wrapping rules). */
  static _estimateFloorBlockHeight(
    floor,
    colW,
    floorSize,
    rowSize,
    padding,
    layoutScale,
    lineHeightFn
  ) {
    const name = String(floor.name || "Floor");
    const nameLines = EditorOps._registerWrappedLineCount(name, floorSize, colW);
    let h = nameLines * lineHeightFn(floorSize) + EditorOps._registerNameGap(layoutScale);
    for (const row of floor.rows || []) {
      const t = String(row.text || "");
      const lines = EditorOps._registerWrappedLineCount(t, rowSize, colW);
      h += lines * lineHeightFn(rowSize) + 2 * layoutScale;
    }
    return h + padding + EditorOps._registerFloorGap(layoutScale);
  }

  /** Space between a floor name and its first row. */
  static _registerNameGap(layoutScale) {
    return 4 * layoutScale;
  }

  /** Extra space between floors, on top of padding; the separator line sits in it. */
  static _registerFloorGap(layoutScale) {
    return 8 * layoutScale;
  }

  /**
   * Draw one floor in a single column at baseX, top y0: the floor name with its rows directly
   * beneath, and — for every floor but the first in its column — a clear line in the gap above
   * it. There is deliberately no line between a floor name and its rows: the old rule there
   * read as a divider, and people went to the wrong floor.
   */
  static _renderFloorInColumn(
    floor,
    baseX,
    y0,
    colW,
    textColor,
    floorSize,
    rowSize,
    padding,
    layoutScale,
    lineHeightFn,
    isFirstInColumn = true
  ) {
    const objs = [];
    let y = y0;

    if (!isFirstInColumn) {
      const sepH = Math.max(1.5, 1.5 * layoutScale);
      const gap = padding + EditorOps._registerFloorGap(layoutScale);
      const sepY = y0 - gap / 2 - sepH / 2;
      if (Number.isFinite(baseX) && Number.isFinite(sepY) && Number.isFinite(colW)) {
        objs.push(
          new fabric.Rect({
            name: EditorOps.REGISTER_FLOOR_SEPARATOR,
            left: baseX,
            top: sepY,
            width: Math.max(1, colW),
            height: sepH,
            fill: textColor,
            opacity: 0.7,
            selectable: false,
            evented: false,
          })
        );
      }
    }

    const nameStr = String(floor.name || "Floor");
    objs.push(
      new fabric.Text(EditorOps._registerHardWrapText(nameStr, floorSize, colW), {
        left: baseX,
        top: y,
        fontSize: floorSize,
        lineHeight: 1.25,
        fill: textColor,
        fontFamily: "Arial",
        fontWeight: "bold",
        selectable: false,
        evented: false,
        objectCaching: false,
      })
    );
    y +=
      EditorOps._registerTextBlockHeight(nameStr, floorSize, colW, lineHeightFn) +
      EditorOps._registerNameGap(layoutScale);

    for (const row of floor.rows || []) {
      const rowStr = String(row.text || " ");
      objs.push(
        new fabric.Text(EditorOps._registerHardWrapText(rowStr, rowSize, colW), {
          left: baseX,
          top: y,
          fontSize: rowSize,
          lineHeight: 1.25,
          fill: textColor,
          fontFamily: "Arial",
          selectable: false,
          evented: false,
          objectCaching: false,
        })
      );
      y +=
        EditorOps._registerTextBlockHeight(rowStr, rowSize, colW, lineHeightFn) +
        2 * layoutScale;
    }
    y += padding + EditorOps._registerFloorGap(layoutScale);
    return { objects: objs, bottomY: y };
  }

  /**
   * Multi-column newspaper flow. When `registerObj.columnCount` is 1–4, that many columns are
   * used. If omitted, legacy auto: 2 columns for 1–2 floors, 3 for 3–4 floors, 4 when more.
   * Whole floors stay together; if they do not fit the current band, the box grows downward.
   * @param {{ shrinkToContent?: boolean }} [options] When shrinkToContent is true (e.g. sidebar
   *   edits), height follows layout instead of being floored by the previous canvas height — avoids
   *   the box and divider lines staying huge after reducing floor/row font sizes.
   */
  static buildRegisterObjects(registerObj, width = 348, height = 500, options = {}) {
    const { shrinkToContent = false } = options;
    const REF_W = 348;
    const numOr = (v, fallback) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : fallback;
    };
    let safeW = Math.max(1, numOr(width, 348));
    let safeH = Math.max(1, numOr(height, 500));
    // Scale typography and horizontal spacing from **width** only. Using min(width, height)
    // caused a death spiral with shrinkToContent: short box → tiny layoutScale → ~0px fonts
    // and invisible content on the next rebuild.
    const layoutScale = safeW / REF_W;
    const padRef = numOr(registerObj.padding, 8);
    const padding = padRef * layoutScale;
    const clampPx = (v) => Math.max(2, v);
    const titleSize = clampPx(
      numOr(registerObj.titleSize, 22) * layoutScale
    );
    const floorSize = clampPx(
      numOr(registerObj.floorSize, 16) * layoutScale
    );
    const rowSize = clampPx(numOr(registerObj.rowSize, 13) * layoutScale);
    const textColor = registerObj.textColor || "#000000";
    const bgColor =
      registerObj.backgroundColor === "transparent"
        ? "transparent"
        : registerObj.backgroundColor || "#1e293b";
    const cornerRadius = numOr(registerObj.cornerRadius, 0) * layoutScale;
    const propertyName = String(registerObj.propertyName ?? "").trim();
    const showTitle = propertyName.length > 0;
    const floors = registerObj.floors || [];

    const lineHeight = (size) => size * 1.25;
    const innerW = Math.max(1, safeW - 2 * padding);
    const colGap = 8 * layoutScale;
    const numFloors = floors.length;
    const legacyAutoCols =
      numFloors <= 2 ? 2 : numFloors <= 4 ? 3 : 4;
    const ccRaw = registerObj.columnCount;
    const ccNum = Number(ccRaw);
    const numCols =
      ccRaw !== undefined &&
      ccRaw !== null &&
      ccRaw !== "" &&
      Number.isFinite(ccNum) &&
      ccNum >= 1 &&
      ccNum <= 4
        ? Math.round(ccNum)
        : legacyAutoCols;
    const colW = Math.max(
      32 * layoutScale,
      (innerW - (numCols - 1) * colGap) / numCols
    );
    const colX = [];
    for (let c = 0; c < numCols; c++) {
      colX.push(padding + c * (colW + colGap));
    }

    const objects = [];
    const rect = new fabric.Rect({
      left: 0,
      top: 0,
      width: safeW,
      height: safeH,
      fill: bgColor,
      rx: cornerRadius,
      ry: cornerRadius,
      selectable: false,
      evented: false,
    });
    objects.push(rect);

    let y = padding;

    if (showTitle) {
      // fabric.Textbox + textAlign inside a Group can trigger infinite setCoords recursion in
      // Fabric 5.x; use Text + center origin (layout width stays canonical via _layoutW).
      const title = new fabric.Text(propertyName, {
        left: padding + innerW / 2,
        top: y,
        originX: "center",
        fontSize: titleSize,
        lineHeight: 1.25,
        fill: textColor,
        fontFamily: "Arial",
        selectable: false,
        evented: false,
        objectCaching: false,
      });
      objects.push(title);
      y += lineHeight(titleSize) + padding;
    }

    const contentTop = y;
    const yCols = Array(numCols).fill(contentTop);
    let maxBottom = Math.max(
      contentTop + 40 * layoutScale,
      safeH - padding
    );

    const appendToCol = (colIdx, floor) => {
      const baseX = colX[colIdx];
      const y0 = yCols[colIdx];
      const { objects: fo, bottomY } = EditorOps._renderFloorInColumn(
        floor,
        baseX,
        y0,
        colW,
        textColor,
        floorSize,
        rowSize,
        padding,
        layoutScale,
        lineHeight,
        y0 === contentTop
      );
      objects.push(...fo);
      yCols[colIdx] = bottomY;
    };

    for (const floor of floors) {
      const h = EditorOps._estimateFloorBlockHeight(
        floor,
        colW,
        floorSize,
        rowSize,
        padding,
        layoutScale,
        lineHeight
      );

      let placed = false;
      for (let c = 0; c < numCols; c++) {
        if (yCols[c] + h <= maxBottom) {
          appendToCol(c, floor);
          placed = true;
          break;
        }
      }
      if (!placed) {
        maxBottom = Math.max(...yCols, contentTop) + h + padding;
        let bestC = 0;
        for (let c = 1; c < numCols; c++) {
          if (yCols[c] < yCols[bestC]) bestC = c;
        }
        appendToCol(bestC, floor);
      }
    }

    // Each column ends with one floor gap that has nothing below it.
    const lastGap = floors.length ? EditorOps._registerFloorGap(layoutScale) : 0;
    const usedBottom = Math.max(...yCols, contentTop) - lastGap + padding;
    const minShellH = contentTop + Math.max(32 * layoutScale, padding);
    const finalH = shrinkToContent
      ? Math.max(usedBottom, minShellH)
      : Math.max(safeH, usedBottom);
    const finalHF = Number.isFinite(finalH) ? finalH : safeH;
    rect.set({ height: finalHF });

    if (numCols > 1 && floors.length > 0) {
      const dividers = [];
      for (let i = 0; i < numCols - 1; i++) {
        const xLine = colX[i] + colW + colGap / 2;
        const yTop = contentTop - 2 * layoutScale;
        const yBotRaw = finalHF - padding;
        const yBot = Math.max(yTop + 1, yBotRaw);
        if (Number.isFinite(xLine) && Number.isFinite(yTop) && Number.isFinite(yBot)) {
          const strokeW = Math.max(1, 0.75 * layoutScale);
          const lineH = Math.max(1, yBot - yTop);
          dividers.push(
            new fabric.Rect({
              left: xLine - strokeW / 2,
              top: yTop,
              width: strokeW,
              height: lineH,
              fill: textColor,
              opacity: 0.22,
              selectable: false,
              evented: false,
            })
          );
        }
      }
      objects.splice(1, 0, ...dividers);
    }

    return objects;
  }

  /**
   * Rebuild directory registers saved before the line between floors existed, in layout JSON
   * that is about to be loaded into the editor. Size, position and settings are kept; only the
   * group's children change. Returns how many registers were rebuilt.
   * @param {object} json Fabric canvas JSON (mutated)
   * @param {string[]} propertiesToInclude same custom props the editor saves with
   */
  static upgradeRegisterFloorStyle(json, propertiesToInclude = []) {
    let upgraded = 0;
    const list = Array.isArray(json && json.objects) ? json.objects : [];
    list.forEach((obj, i) => {
      if (!obj || obj.eleType !== "directory-register" || !obj.registerObj) return;
      const floors = obj.registerObj.floors || [];
      if (!floors.length || !Array.isArray(obj.objects)) return;
      if (obj.registerObj._floorStyle === EditorOps.REGISTER_FLOOR_STYLE) return;
      if (obj.angle || obj.flipX || obj.flipY) return; // keep unusual transforms as they are
      try {
        // _layoutW/_layoutH are the box size without the 1px stroke Fabric adds to group bounds
        const lw = Number(obj.registerObj._layoutW);
        const lh = Number(obj.registerObj._layoutH);
        const scaled = Math.abs(obj.scaleX || 1) === 1 && Math.abs(obj.scaleY || 1) === 1;
        const w = scaled && lw > 0 ? lw : Math.max(1, (obj.width || 348) * Math.abs(obj.scaleX || 1));
        const h = scaled && lh > 0 ? lh : Math.max(1, (obj.height || 500) * Math.abs(obj.scaleY || 1));
        const group = new fabric.Group(EditorOps.buildRegisterObjects(obj.registerObj, w, h), {
          left: obj.left,
          top: obj.top,
          originX: obj.originX || "left",
          originY: obj.originY || "top",
        });
        const out = group.toObject(propertiesToInclude);
        list[i] = {
          ...obj,
          registerObj: { ...obj.registerObj, _floorStyle: EditorOps.REGISTER_FLOOR_STYLE },
          objects: out.objects,
          width: out.width,
          height: out.height,
          left: out.left,
          top: out.top,
          scaleX: 1,
          scaleY: 1,
        };
        upgraded += 1;
      } catch (e) {
        // leave this register as it was saved
      }
    });
    return upgraded;
  }

  addDirectoryRegister(registerObj, cb) {
    const data = {
      propertyName: registerObj.propertyName ?? "",
      floors: Array.isArray(registerObj.floors) ? registerObj.floors : [],
      titleSize: registerObj.titleSize ?? 22,
      floorSize: registerObj.floorSize ?? 16,
      rowSize: registerObj.rowSize ?? 13,
      padding: registerObj.padding ?? 8,
      cornerRadius: registerObj.cornerRadius ?? 0,
      backgroundColor: registerObj.backgroundColor ?? "transparent",
      textColor: registerObj.textColor ?? "#000000",
    };
    const ccAdd = Number(registerObj.columnCount);
    if (
      registerObj.columnCount !== undefined &&
      registerObj.columnCount !== null &&
      registerObj.columnCount !== "" &&
      Number.isFinite(ccAdd) &&
      ccAdd >= 1 &&
      ccAdd <= 4
    ) {
      data.columnCount = Math.round(ccAdd);
    }
    const objects = EditorOps.buildRegisterObjects(data, 348, 500);
    const firstRect = objects[0];
    data._layoutW = firstRect.width;
    data._layoutH = firstRect.height;
    data._floorStyle = EditorOps.REGISTER_FLOOR_STYLE;
    const group = new fabric.Group(objects, {
      left: 50,
      top: 50,
      subTargetCheck: false,
      hasBorders: true,
      hasControls: true,
      lockRotation: true,
    });
    group.id = uuid();
    group.eleType = "directory-register";
    group.registerObj = data;
    group.setCoords();
    cb(group);
  }

  /** Library / layout still images (not playlist, weather, QR, etc.). */
  static isNorLayoutImage(img) {
    return (
      img &&
      (img.eleType === "nor-image" ||
        (img.type === "nor-image" && !img.contents && !img.weatherObj))
    );
  }

  /** object-fit: cover — fill layoutWidth×layoutHeight, centered. */
  static fitNorImageCoverLayout(img, layoutWidth, layoutHeight) {
    if (!img || !layoutWidth || !layoutHeight) return;
    let iw = img.width || 1;
    let ih = img.height || 1;
    try {
      const el = typeof img.getElement === "function" ? img.getElement() : null;
      if (el && el.naturalWidth > 0) {
        iw = el.naturalWidth;
        ih = el.naturalHeight;
      }
    } catch (_) {
      /* keep img.width / img.height */
    }
    iw = Math.max(iw, 1e-6);
    ih = Math.max(ih, 1e-6);
    const scale = Math.max(layoutWidth / iw, layoutHeight / ih);
    img.set({
      originX: "center",
      originY: "center",
      left: layoutWidth / 2,
      top: layoutHeight / 2,
      scaleX: scale,
      scaleY: scale,
      angle: 0,
    });
    img.setCoords();
  }

  static _norImageFromSrc(img, cb) {
    const src =
      (typeof img.getSrc === "function" && img.getSrc()) ||
      (img._originalElement && img._originalElement.src) ||
      img.url ||
      "";
    if (!src) {
      cb(null);
      return;
    }
    loadImageForFabric(src)
      .then(({ img: loaded }) => cb(loaded))
      .catch((err) => {
        console.error("_norImageFromSrc failed:", src, err);
        cb(null);
      });
  }

  /**
   * Canvas background (behind all objects), full cover. Removes the source layer.
   */
  static setNorImageAsCanvasBackground(
    canvas,
    img,
    layoutWidth,
    layoutHeight,
    onDone
  ) {
    const done = typeof onDone === "function" ? onDone : () => {};
    if (!canvas || !img || !EditorOps.isNorLayoutImage(img)) {
      done(false);
      return;
    }
    const applyBg = (bgImg) => {
      if (!bgImg) {
        done(false);
        return;
      }
      EditorOps.fitNorImageCoverLayout(bgImg, layoutWidth, layoutHeight);
      bgImg.set({
        selectable: false,
        evented: false,
        hasControls: false,
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
      });
      canvas.backgroundImage = bgImg;
      canvas.remove(img);
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      done(true);
    };
    if (typeof img.clone === "function") {
      try {
        img.clone((cloned) => {
          if (cloned) applyBg(cloned);
          else EditorOps._norImageFromSrc(img, applyBg);
        });
      } catch (_) {
        EditorOps._norImageFromSrc(img, applyBg);
      }
    } else {
      EditorOps._norImageFromSrc(img, applyBg);
    }
  }

  static _ordinalDay(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  /** Strings for the gradient-night clock face (fixed layout size). */
  static formatClockFace(now = new Date()) {
    // 24-hour clock, no AM/PM; Swedish date ("måndag 19 oktober")
    const main = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
    const dateLine = now.toLocaleDateString("sv-SE", { weekday: "long", day: "numeric", month: "long" });
    return { main, sub: "", dateLine };
  }

  /**
   * @param {{ variant?: string }} _clockObj
   */
  static buildClockWidgetObjects(_clockObj) {
    const variant = _clockObj?.variant || "gradient-night";
    if (variant === "neumorphic-analog") {
      return EditorOps.buildNeumorphicAnalogClockObjects();
    }
    if (variant === "liquid-crystal") {
      return EditorOps.buildLiquidCrystalClockObjects();
    }
    if (variant === "longform-analog") {
      return EditorOps.buildLongformAnalogClockObjects();
    }
    return EditorOps.buildGradientNightClockObjects();
  }

  /** Digital LCD bar — native size 420×100; text updates via refreshClockWidgets. */
  static buildLiquidCrystalClockObjects() {
    const W = 420;
    const H = 100;
    const line = formatLiquidCrystalDateTime(new Date());
    const rect = new fabric.Rect({
      left: 0,
      top: 0,
      width: W,
      height: H,
      rx: 15,
      ry: 15,
      fill: "#222222",
      name: "clock-lcd-bg",
      selectable: false,
      evented: false,
    });
    rect.set({
      shadow: new fabric.Shadow({
        color: "rgba(0,0,0,0.85)",
        blur: 7,
        offsetX: 0,
        offsetY: 0,
      }),
    });
    const txt = new fabric.Text(line, {
      left: W / 2,
      top: H / 2,
      originX: "center",
      originY: "center",
      fontSize: 17,
      fill: "#eeeeee",
      fontFamily: "liquid_crystalregular, Share Tech Mono, Segoe UI Mono, monospace",
      fontWeight: "normal",
      textAlign: "center",
      name: "clock-lcd-text",
      selectable: false,
      evented: false,
      shadow: new fabric.Shadow({
        color: "rgba(255,255,255,0.4)",
        blur: 3,
        offsetX: 0,
        offsetY: 0,
      }),
    });
    return [rect, txt];
  }

  /** Digital gradient card — native size 280×150. */
  static buildGradientNightClockObjects() {
    const { main, sub, dateLine } = EditorOps.formatClockFace();

    const REF_W = 280;
    const REF_H = 150;

    const rect = new fabric.Rect({
      left: 0,
      top: 0,
      width: REF_W,
      height: REF_H,
      rx: 15,
      ry: 15,
      name: "clock-gradient-card",
      selectable: false,
      evented: false,
    });
    rect.set({
      fill: new fabric.Gradient({
        type: "linear",
        gradientUnits: "pixels",
        coords: { x1: 0, y1: 0, x2: REF_W, y2: 0 },
        colorStops: [
          { offset: 0, color: "rgb(20,30,48)" },
          { offset: 1, color: "rgb(36,59,85)" },
        ],
      }),
    });
    rect.set({
      shadow: new fabric.Shadow({
        color: "rgba(0,0,0,0.45)",
        blur: 22,
        offsetX: 4,
        offsetY: 8,
      }),
    });

    const timeMain = new fabric.Text(main, {
      left: 15,
      top: 20,
      fontSize: 50,
      fontWeight: "600",
      fill: "#ffffff",
      fontFamily: "Calibri, Gill Sans, Trebuchet MS, sans-serif",
      selectable: false,
      evented: false,
      name: "clock-time-main",
    });

    const tw = timeMain.width || 110;
    const timeSub = new fabric.Text(sub, {
      left: 15 + tw + 8,
      top: 50,
      fontSize: 15,
      fill: "#ffffff",
      fontFamily: "Calibri, Gill Sans, sans-serif",
      selectable: false,
      evented: false,
      name: "clock-time-sub",
    });

    const dateText = new fabric.Text(dateLine, {
      left: 15,
      top: 92,
      fontSize: 18,
      fontWeight: "500",
      fill: "#ffffff",
      fontFamily: "Calibri, Gill Sans, sans-serif",
      selectable: false,
      evented: false,
      name: "clock-date",
    });

    const moonPath =
      "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z";
    const moon = new fabric.Path(moonPath, {
      left: 246,
      top: 14,
      fill: "#ffffff",
      scaleX: 1.2,
      scaleY: 1.2,
      originX: "left",
      originY: "top",
      selectable: false,
      evented: false,
      name: "clock-moon",
    });

    return [rect, timeMain, timeSub, dateText, moon];
  }

  /** Center + hand angles/lengths for neumorphic analog (canvas coords inside 300×300 group). */
  static getNeumorphicAnalogHandGeometry(now = new Date()) {
    const cx = 150;
    const cy = 150;
    const ms = now.getMilliseconds() / 1000;
    const sec = now.getSeconds() + ms;
    const min = now.getMinutes() + sec / 60;
    const hr = (now.getHours() % 12) + min / 60;
    const thetaHr = -Math.PI / 2 + (hr / 12) * 2 * Math.PI;
    const thetaMin = -Math.PI / 2 + (min / 60) * 2 * Math.PI;
    const thetaSec = -Math.PI / 2 + (sec / 60) * 2 * Math.PI;
    return {
      cx,
      cy,
      hour: { len: 52, theta: thetaHr },
      minute: { len: 82, theta: thetaMin },
      second: { len: 102, theta: thetaSec },
    };
  }

  /**
   * Soft neumorphic analog clock — native size 300×300 (matches reference layout).
   */
  static buildNeumorphicAnalogClockObjects(now = new Date()) {
    const cx = 150;
    const cy = 150;
    const objects = [];
    const geo = EditorOps.getNeumorphicAnalogHandGeometry(now);

    const bg = new fabric.Rect({
      left: 0,
      top: 0,
      width: 300,
      height: 300,
      fill: "#e0e5ec",
      name: "clock-analog-bg",
      selectable: false,
      evented: false,
    });
    objects.push(bg);

    const faceOuter = new fabric.Circle({
      radius: 150,
      left: cx,
      top: cy,
      originX: "center",
      originY: "center",
      fill: "#e0e5ec",
      name: "clock-analog-face-outer",
      selectable: false,
      evented: false,
      shadow: new fabric.Shadow({
        color: "rgba(163,177,198,0.55)",
        blur: 22,
        offsetX: 10,
        offsetY: 10,
      }),
    });
    objects.push(faceOuter);

    const faceInner = new fabric.Circle({
      radius: 136,
      left: cx,
      top: cy,
      originX: "center",
      originY: "center",
      fill: "#e0e5ec",
      stroke: "#eef2f7",
      strokeWidth: 2,
      name: "clock-analog-face-inner",
      selectable: false,
      evented: false,
      shadow: new fabric.Shadow({
        color: "rgba(255,255,255,0.45)",
        blur: 6,
        offsetX: -4,
        offsetY: -4,
      }),
    });
    objects.push(faceInner);

    const markerR = 132;
    for (let i = 0; i < 12; i++) {
      const ang = -Math.PI / 2 + (i * Math.PI) / 6;
      const mx = cx + markerR * Math.cos(ang);
      const my = cy + markerR * Math.sin(ang);
      const big = i % 3 === 0;
      objects.push(
        new fabric.Circle({
          radius: big ? 4 : 3,
          left: mx,
          top: my,
          originX: "center",
          originY: "center",
          fill: "#e0e5ec",
          stroke: "#c5cedd",
          strokeWidth: 0.5,
          name: "clock-analog-tick",
          selectable: false,
          evented: false,
        })
      );
    }

    const numR = 110;
    for (let n = 1; n <= 12; n++) {
      const hIdx = n === 12 ? 0 : n;
      const angleRad = -Math.PI / 2 + (hIdx * Math.PI) / 6;
      const tx = cx + numR * Math.cos(angleRad);
      const ty = cy + numR * Math.sin(angleRad);
      objects.push(
        new fabric.Text(String(n), {
          left: tx,
          top: ty,
          fontSize: 24,
          fontWeight: "600",
          fill: "#b8c1d1",
          fontFamily: "Helvetica Neue, Arial, sans-serif",
          originX: "center",
          originY: "center",
          name: "clock-analog-digit",
          shadow: new fabric.Shadow({
            color: "rgba(255,255,255,0.7)",
            blur: 0,
            offsetX: 1,
            offsetY: 1,
          }),
          selectable: false,
          evented: false,
        })
      );
    }

    /** Hands extend from center along +x locally; `angle` points them on the face (group-safe vs absolute x1/y1). */
    const hand = (name, len, theta, strokeW, stroke) => {
      const deg = (theta * 180) / Math.PI;
      return new fabric.Line([0, 0, len, 0], {
        name,
        originX: "left",
        originY: "center",
        left: cx,
        top: cy,
        angle: deg,
        stroke,
        strokeWidth: strokeW,
        strokeLineCap: "round",
        selectable: false,
        evented: false,
        shadow: new fabric.Shadow({
          color: "rgba(0,0,0,0.12)",
          blur: 4,
          offsetX: 2,
          offsetY: 2,
        }),
      });
    };

    objects.push(
      hand("clock-hand-hour", geo.hour.len, geo.hour.theta, 8, "#4a5463")
    );
    objects.push(
      hand("clock-hand-minute", geo.minute.len, geo.minute.theta, 6, "#7a8a9e")
    );
    objects.push(
      hand("clock-hand-second", geo.second.len, geo.second.theta, 3, "#e65e5e")
    );

    const pin = new fabric.Circle({
      radius: 10,
      left: cx,
      top: cy,
      originX: "center",
      originY: "center",
      fill: "#e0e5ec",
      name: "clock-analog-pin-outer",
      selectable: false,
      evented: false,
      shadow: new fabric.Shadow({
        color: "rgba(163,177,198,0.5)",
        blur: 5,
        offsetX: 2,
        offsetY: 2,
      }),
    });
    objects.push(pin);
    objects.push(
      new fabric.Circle({
        radius: 3,
        left: cx,
        top: cy,
        originX: "center",
        originY: "center",
        fill: "#4a5463",
        name: "clock-analog-pin-inner",
        selectable: false,
        evented: false,
      })
    );

    return objects;
  }

  /** Hand geometry for longform text-dial analog (300×300, lengths match reference HTML/CSS). */
  static getLongformAnalogHandGeometry(now = new Date()) {
    const cx = 150;
    const cy = 150;
    const ms = now.getMilliseconds() / 1000;
    const sec = now.getSeconds() + ms;
    const min = now.getMinutes() + sec / 60;
    const hr = (now.getHours() % 12) + min / 60;
    const thetaHr = -Math.PI / 2 + (hr / 12) * 2 * Math.PI;
    const thetaMin = -Math.PI / 2 + (min / 60) * 2 * Math.PI;
    const thetaSec = -Math.PI / 2 + (sec / 60) * 2 * Math.PI;
    return {
      cx,
      cy,
      hour: { len: 80, theta: thetaHr },
      minute: { len: 120, theta: thetaMin },
      second: { len: 130, theta: thetaSec },
    };
  }

  /**
   * Longform text + analog hands — native size 300×300 (ported from reference HTML/CSS).
   */
  static buildLongformAnalogClockObjects() {
    const cx = 150;
    const cy = 150;
    const geo = EditorOps.getLongformAnalogHandGeometry(new Date());
    const { hourWord, minuteWord, calendarLine } = formatLongformClockDisplay(new Date());
    const handStroke = "#b7ddf0";

    const face = new fabric.Circle({
      radius: 138,
      left: cx,
      top: cy,
      originX: "center",
      originY: "center",
      fill: new fabric.Gradient({
        type: "linear",
        gradientUnits: "pixels",
        coords: { x1: 0, y1: 300, x2: 300, y2: 0 },
        colorStops: [
          { offset: 0, color: "#39454b" },
          { offset: 0.22, color: "#39454b" },
          { offset: 1, color: "#101017" },
        ],
      }),
      stroke: "#39454b",
      strokeWidth: 10,
      name: "clock-longform-face",
      selectable: false,
      evented: false,
    });
    face.set({
      shadow: new fabric.Shadow({
        color: "rgba(145, 158, 165, 0.9)",
        blur: 5,
        offsetX: 15,
        offsetY: 15,
      }),
    });

    const longformLine = (name, len, theta, w) => {
      const deg = (theta * 180) / Math.PI;
      return new fabric.Line([0, 0, len, 0], {
        name,
        originX: "left",
        originY: "center",
        left: cx,
        top: cy,
        angle: deg,
        stroke: handStroke,
        strokeWidth: w,
        strokeLineCap: "round",
        selectable: false,
        evented: false,
      });
    };

    const hourHand = longformLine("clock-longform-hour-hand", geo.hour.len, geo.hour.theta, 4);
    const minuteHand = longformLine("clock-longform-minute-hand", geo.minute.len, geo.minute.theta, 4);

    const secLine = new fabric.Line([0, 0, 130, 0], {
      originX: "left",
      originY: "center",
      left: 0,
      top: 0,
      stroke: handStroke,
      strokeWidth: 2,
      strokeLineCap: "round",
      selectable: false,
      evented: false,
    });
    const secRing = new fabric.Ellipse({
      left: 130,
      top: 0,
      originX: "center",
      originY: "center",
      rx: 6,
      ry: 5,
      fill: "transparent",
      stroke: handStroke,
      strokeWidth: 1,
      selectable: false,
      evented: false,
    });
    const secondGroup = new fabric.Group([secLine, secRing], {
      left: cx,
      top: cy,
      originX: "center",
      originY: "center",
      name: "clock-longform-second-hand",
      selectable: false,
      evented: false,
    });
    secondGroup.set({ angle: (geo.second.theta * 180) / Math.PI });

    const textBase = {
      fontFamily: "Arial, Helvetica, sans-serif",
      fontSize: 16,
      fill: "#ffffff",
      originX: "center",
      originY: "center",
      textAlign: "center",
      selectable: false,
      evented: false,
    };
    const hourText = new fabric.Text(hourWord || "—", {
      ...textBase,
      left: cx,
      top: 70,
      width: 260,
      name: "clock-longform-hour-text",
    });
    const minuteText = new fabric.Text(minuteWord || " ", {
      ...textBase,
      left: cx,
      top: 96,
      width: 260,
      name: "clock-longform-minute-text",
    });
    const calText = new fabric.Text(calendarLine, {
      ...textBase,
      fontSize: 14,
      left: cx,
      top: 228,
      width: 260,
      name: "clock-longform-calendar-text",
    });

    const dial = new fabric.Circle({
      radius: 10,
      left: cx,
      top: cy,
      originX: "center",
      originY: "center",
      fill: "#4c5c64",
      stroke: "#101017",
      strokeWidth: 1,
      strokeDashArray: [2, 2],
      name: "clock-longform-dial",
      selectable: false,
      evented: false,
    });

    return [
      face,
      hourHand,
      minuteHand,
      secondGroup,
      hourText,
      minuteText,
      calText,
      dial,
    ];
  }

  addClockWidget(clockObj, cb) {
    const data = {
      variant: clockObj?.variant || "gradient-night",
      style: { ...(clockObj?.style && typeof clockObj.style === "object" ? clockObj.style : {}) },
    };
    const objects = EditorOps.buildClockWidgetObjects(data);
    const group = new fabric.Group(objects, {
      left: 120,
      top: 120,
      subTargetCheck: false,
      hasBorders: true,
      hasControls: true,
      lockRotation: true,
    });
    group.id = uuid();
    group.eleType = "clock-widget";
    group.clockObj = data;
    cb(group);
  }

  static _weatherText(name, text, opts) {
    return new fabric.Text(text, {
      name,
      selectable: false,
      evented: false,
      fontFamily: "Calibri, Segoe UI, sans-serif",
      objectCaching: false,
      ...opts,
    });
  }

  static _weatherIcon(name, emoji, opts) {
    return new fabric.Text(emoji, {
      name,
      selectable: false,
      evented: false,
      fontFamily: WEATHER_ICON_FONT,
      objectCaching: false,
      ...opts,
    });
  }

  static _weatherCardBg(w, h, variant, style) {
    const rect = new fabric.Rect({
      left: 0,
      top: 0,
      width: w,
      height: h,
      rx: variant === "minimal" ? 10 : 14,
      ry: variant === "minimal" ? 10 : 14,
      name: "weather-card-bg",
      selectable: false,
      evented: false,
    });
    if (variant === "minimal") {
      rect.set({ fill: style.cardBg });
    } else {
      rect.set({
        fill: new fabric.Gradient({
          type: "linear",
          gradientUnits: "pixels",
          coords: { x1: 0, y1: 0, x2: w, y2: h },
          colorStops: [
            { offset: 0, color: style.cardBg },
            { offset: 1, color: style.cardBgEnd },
          ],
        }),
      });
    }
    return rect;
  }

  static buildWeatherWidgetObjects(weatherObj) {
    const variant = weatherObj?.variant || "glass-card";
    const style = mergeWeatherObjStyle(weatherObj);
    const cached = weatherObj?.cached || defaultWeatherSnapshot(weatherObj?.city);
    const unit = weatherObj?.unit || "metric";
    const tempStr = formatTempDisplay(cached.temp, unit);
    const desc =
      String(cached.description || "—").charAt(0).toUpperCase() +
      String(cached.description || "—").slice(1);
    const meta = `Humidity ${cached.humidity}% · Wind ${formatWindDisplay(cached.wind, unit)}`;
    const emoji = weatherIconEmoji(cached.iconCode, cached.description);

    if (variant === "minimal") {
      const W = 260;
      const H = 56;
      const line = `${tempStr} · ${desc} · ${cached.cityLabel || weatherObj?.city || "City"}`;
      return [
        EditorOps._weatherCardBg(W, H, variant, style),
        EditorOps._weatherIcon("weather-icon-text", emoji, {
          left: 22,
          top: H / 2,
          originX: "center",
          originY: "center",
          fontSize: 18,
          fill: style.textColor,
          opacity: 0.9,
        }),
        EditorOps._weatherText("weather-minimal-text", line, {
          left: 44,
          top: H / 2,
          originY: "center",
          fontSize: 14,
          fontWeight: "600",
          fill: style.textColor,
          width: W - 52,
        }),
      ];
    }

    if (variant === "compact") {
      const W = 260;
      const H = 108;
      return [
        EditorOps._weatherCardBg(W, H, variant, style),
        EditorOps._weatherIcon("weather-icon-text", emoji, {
          left: 36,
          top: 42,
          originX: "center",
          originY: "center",
          fontSize: 34,
          fill: style.textColor,
          opacity: 0.92,
        }),
        EditorOps._weatherText("weather-city-text", cached.cityLabel || weatherObj?.city || "City", {
          left: 88,
          top: 18,
          fontSize: 14,
          fontWeight: "600",
          fill: style.accentColor,
        }),
        EditorOps._weatherText("weather-temp-text", tempStr, {
          left: 88,
          top: 38,
          fontSize: 32,
          fontWeight: "700",
          fill: style.textColor,
        }),
        EditorOps._weatherText("weather-desc-text", desc, {
          left: 88,
          top: 72,
          fontSize: 13,
          fill: style.textColor,
        }),
        EditorOps._weatherText("weather-meta-text", meta, {
          left: 16,
          top: 90,
          fontSize: 11,
          fill: style.metaColor,
        }),
      ];
    }

    const W = 300;
    const H = 158;
    return [
      EditorOps._weatherCardBg(W, H, "glass-card", style),
      EditorOps._weatherIcon("weather-icon-text", emoji, {
        left: W - 36,
        top: 28,
        originX: "center",
        originY: "center",
        fontSize: 42,
        fill: style.textColor,
        opacity: 0.92,
      }),
      EditorOps._weatherText("weather-city-text", cached.cityLabel || weatherObj?.city || "City", {
        left: 20,
        top: 18,
        fontSize: 16,
        fontWeight: "600",
        fill: style.accentColor,
      }),
      EditorOps._weatherText("weather-temp-text", tempStr, {
        left: 20,
        top: 48,
        fontSize: 48,
        fontWeight: "700",
        fill: style.textColor,
      }),
      EditorOps._weatherText("weather-desc-text", desc, {
        left: 20,
        top: 104,
        fontSize: 15,
        fill: style.textColor,
      }),
      EditorOps._weatherText("weather-meta-text", meta, {
        left: 20,
        top: 128,
        fontSize: 12,
        fill: style.metaColor,
      }),
    ];
  }

  addWeatherWidget(weatherObj, cb) {
    const data = {
      variant: weatherObj?.variant || "glass-card",
      city: weatherObj?.city || "Stockholm",
      lat: weatherObj?.lat ?? "",
      lng: weatherObj?.lng ?? "",
      unit: weatherObj?.unit || "metric",
      style: { ...(weatherObj?.style || {}) },
      cached: weatherObj?.cached || defaultWeatherSnapshot(weatherObj?.city || "Stockholm"),
    };
    const objects = EditorOps.buildWeatherWidgetObjects(data);
    const group = new fabric.Group(objects, {
      left: 120,
      top: 120,
      subTargetCheck: false,
      hasBorders: true,
      hasControls: true,
      lockRotation: true,
    });
    group.id = uuid();
    group.eleType = "weather-widget";
    group.weatherObj = data;
    group.setCoords();
    cb(group);
  }
}
